import { render } from "./index.vue?vue&type=template&id=cfaad70a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=cfaad70a&scoped=true&lang=scss"

import exportComponent from "F:\\webWork\\demo\\h5sdk2\\h5sdk2.muugame.com\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfaad70a"]])

export default __exports__